import { Typography } from "@mui/material";
import { createColumnHelper } from "@tanstack/react-table";

import { tk } from "@thalamos/vision-common";

import { TypographyI18N } from "../../TypographyI18N/TypographyI18N.js";
import { ActionsCell } from "./cells/ActionsCell.js";
import type { IncidentTableRow } from "./types.js";

const columnHelper = createColumnHelper<IncidentTableRow>();

export const columns = [
  columnHelper.accessor("typeOfIncident", {
    header: () => (
      <TypographyI18N
        translationKey={tk("incidentWorkItem.typeOfIncident")}
        fontWeight="bold"
      />
    ),
    cell: (info) => <Typography>{info.getValue()}</Typography>,
  }),
  columnHelper.accessor("createdAt", {
    header: () => (
      <TypographyI18N
        translationKey={tk("incidentWorkItem.createdAt")}
        fontWeight="bold"
      />
    ),
    cell: (info) => <Typography>{info.getValue()}</Typography>,
  }),
  columnHelper.accessor("nameOfPerson", {
    header: () => (
      <TypographyI18N
        translationKey={tk("incidentWorkItem.nameOfPerson")}
        fontWeight="bold"
      />
    ),
    cell: (info) => <Typography>{info.getValue()}</Typography>,
  }),
  columnHelper.accessor("commandUnit", {
    header: () => (
      <TypographyI18N
        translationKey={tk("incidentWorkItem.commandUnit")}
        fontWeight="bold"
      />
    ),
    cell: (info) => <Typography>{info.getValue()}</Typography>,
  }),
  columnHelper.accessor("currentAssignee", {
    header: () => (
      <TypographyI18N
        translationKey={tk("incidentWorkItem.currentAssignee")}
        fontWeight="bold"
      />
    ),
    cell: (info) => <Typography>{info.getValue()}</Typography>,
  }),
  columnHelper.display({
    id: "actions",
    header: () => null,
    cell: (info) => <ActionsCell row={info.row.original} />,
  }),
];
